import React, { Component } from 'react';
import { exportToCSV, exportToImage } from '../actions/export-report-action-creators';

import DownloadMenu from '../components/download-menu';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isFetchingChartNameSelector } from '../selectors/reports-selectors';

export class DownloadMenuContainer extends Component{

    handleExportToImage = () => {
        const { exportToImage, chartName } = this.props;
        exportToImage( chartName );
    };

    handleDownload = () => {
        const { exportToCSV, tableNameToExport } = this.props;

        exportToCSV( tableNameToExport );
    };

    render(){
        const { chartName, isFetchingImage, tableNameToExport } = this.props;
        return (
            <DownloadMenu
                isFetchingImage={isFetchingImage}
                exportToImage={chartName && this.handleExportToImage}
                exportToCSV={tableNameToExport && this.handleDownload}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = ( state, props ) => {
    return {
        isFetchingImage: isFetchingChartNameSelector( state, props.chartName )
    };
};

DownloadMenuContainer.propTypes = {
    chartName: PropTypes.string.isRequired,
    exportToCSV: PropTypes.func,
    exportToImage: PropTypes.func,
    isFetchingImage: PropTypes.bool,
    tableNameToExport: PropTypes.string
};

export default connect( mapStateToProps, { exportToCSV , exportToImage }  )( DownloadMenuContainer );
